import React, { useState } from 'react';
import fileDownload from 'js-file-download';
import Content from '../components/Content';
import { Box, Card, CardContent, CardHeader } from '@material-ui/core';
import FormReport from '../components/reports/FormReport';
import { reportUsersSessions } from '../services/api';
import moment from 'moment';
import fileName from '../utils/fileName';
import generateCsv from '../services/reports';

const ReportSessions = ({
  userStore
}) => {

  const [loading, setLoading] = useState(false);

  const handleGenerateReport = async (values) => {
    setLoading(true);

    generateCsv(
      `${ process.env.REACT_APP_API_URL }reports/users/sessions`,
      userStore.token,
      values,
      () => setLoading(false),
      () => setLoading(false),
    );
  }

  return (
    <Content title="Relatório de sessões" userStore={userStore}>
      <Card>
        <Box>
          <CardHeader title="Período das sessões" />
          <CardContent>
            <FormReport
              users={userStore} 
              loading={loading} 
              onSubmit={(value) => {
                const data = {
                  ...value,
                  startDate: moment(value.startDate).format(),
                  endDate: moment(value.endDate).format() 
                };

                handleGenerateReport(data);
              }}
            />
          </CardContent>
        </Box>
      </Card>
    </Content>
  );
};

export default ReportSessions;
